
export default {
  name: 'icon-lounge',
};
